import { action as apiAction } from 'api/Api'
import {
  remove as removeChecklist
} from '../redux/elements'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistId: number
  statusId?: number
  template?: any
}

const requestConvertChecklistToSubCardGroup = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, checklistId, statusId, template } = payload

  const args: any = {
    checklistId,
    template,
  }
  if (statusId) {
    args.cardsTarget = {
      statusId,
      statusPosition: 'top'
    }
  }

  const optimisticAction = optimisticDispatch(dispatch, removeChecklist({
    cardId,
    elementId: checklistId
  }))

  const state = getState()

  sweetalert({
    type: 'info',
    text: state.kanbo.locale.messages['CHECKLIST_CONVERT_TO_SUBCARD_GROUP_IN_PROGRESS'],
    showConfirmButton: false,
    allowOutsideClick: false
  }).catch(sweetalert.noop)

  try {
    await apiAction('ConvertChecklistToSubCardList', args)

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  } finally {
    sweetalert.close()
  }
}

export default requestConvertChecklistToSubCardGroup
